import { TailwindWrapper } from "@utils/TailwindWrapper";
import { Text } from "@ui-component-library";

const Banner = (props) => {
  return (
    <TailwindWrapper>
      <section className="w-full bg-[#DFFF5D] cursor-pointer py-6" onClick={() => window.location.href = props.action}>
        <div className="container">
          <Text tw variant="text-base/leading-normal/normal">
            {props.text}
          </Text>
        </div>
      </section>
    </TailwindWrapper>
  );
};

Banner.defaultProps = {
  text: "Feature-rich text that captures attention",
  action: "/"
};

Banner.fields = {
  text: {
    type: "text",
    label: "Banner text",
  },
  action: {
    type: "text",
    label: "Banner action",
  },
};

export default Banner;
